import { render } from "./NewContact.vue?vue&type=template&id=35d98756"
import script from "./NewContact.vue?vue&type=script&lang=js"
export * from "./NewContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__